import { matchPath } from 'react-router';

import { EAdminRoutes } from '@/services/router/enums';

export const checkIsPathMatch = (path: EAdminRoutes, end = true): boolean => {
    return !!matchPath({ path, end }, location.pathname);
};
